// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"ProfileActivityFeed_headerWrapper__33MV0","nounInfoPadding":"ProfileActivityFeed_nounInfoPadding__2Om27"};